import React from "react";
// components
import MNPGV2 from "./MNPGV2";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG007 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG007.rendered", props);

    if ( !props.template ) return null;

    return (
        <div
            className="col-xl-5 col-md-6 "
            data-aos-duration="800"
            data-aos="fade-up"
            data-aos-delay="300"
        >
            <div className="single-footer-widget">
                <MNPGV2 templates={props.templates} mapLayoutName={props.template?.mapLayoutName} parentId={props.template?.id} allowedComponent={["MNPG_066"]} />
                <div className="footer-content style-two">
                    <MNPGV2 templates={props.templates} mapLayoutName={props.template?.mapLayoutName} parentId={props.template?.id} allowedComponent={["MNPG_067", "MNPG_068"]} />
                </div>
            </div>
        </div>
    )
}

const Component = React.memo(MNPG007, (prevProps: TMainPageLayoutV2, nextProps: TMainPageLayoutV2) => {
    console.log("MNPG007.memo", { prevProps, nextProps });
    return true;
});

export default Component;
